import { ErrorResponseBody } from '../api-clients';
import { BaseError } from '../../errors/BaseError';
import { ValidationError } from "./index";

/**
 * リクエスト不正エラー例外
 */
export class ApiClientError extends BaseError {
  public readonly status: number;

  public readonly code: number;

  public readonly message: string;

  public readonly errors?: ValidationError[];

  constructor(body: ErrorResponseBody, status: number) {
    super(body.message);

    this.status = status;
    this.code = body.code;
    this.message = body.message;
    this.errors = body.errors;
  }
}